import { useState } from 'react';

import { Grid, Typography } from '@mui/material';

import { navigate } from '@redwoodjs/router';
import { MetaTags, useQuery } from '@redwoodjs/web';

import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { showErrorToast } from 'src/components/Toasts/toast';
import { DEFAULT_BORDER, ROUTES } from 'src/constants';
import selfBillingInvoiceGridColDefs from 'src/features/finance/selfBillingSalesInvoice/selfBillingInvoiceGridColDefs';

import { GET_SELF_BILLING_INVOICES } from '../../graphql/queries/getSelfBillingInvoices.query';

const ViewSelfBillingInvoicesPage = () => {
    const [tableData, setTableData] = useState([]);

    const { loading } = useQuery(GET_SELF_BILLING_INVOICES, {
        initialFetchPolicy: 'no-cache',
        onError: (error) => {
            showErrorToast(error.message);
        },
        onCompleted: (data) => {
            const dataForTable = data?.selfBillingInvoices?.map((el) => {
                return {
                    ...el,
                    invoiceDate: el.invoiceDate,
                    dateAdded: el.createdAt,
                    status: el.status,
                    partnerName: `${el?.partner?.firstName} ${el?.partner?.lastName}`,
                };
            });

            setTableData(dataForTable);
        },
    });

    const handleViewSelfBillingInvoice = (rowItem) => {
        navigate(`${ROUTES.finance.selfBillingInvoices}/${rowItem.id}`);
    };

    return (
        <>
            <MetaTags title="Self-Billing Invoices page" description="Self-Billing Invoices page" />

            <Grid container sx={{ gap: '24px' }}>
                <Grid
                    item
                    xs={12}
                    sx={{
                        ...DEFAULT_BORDER,
                        height: '116px',
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '8px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    }}
                >
                    <Typography sx={{ fontSize: '24px', fontWeight: 700, color: '#1D1D1B' }}>
                        Self-Billing Invoices
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {loading ? (
                        <Loader />
                    ) : (
                        <NPIDataGrid
                            rows={tableData}
                            columns={selfBillingInvoiceGridColDefs()}
                            getRowId={(row) => {
                                return row.id;
                            }}
                            handleView={handleViewSelfBillingInvoice}
                            title="Check-in Calls Page"
                            dataTestId="check-in-calls-page-table"
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
};

export default ViewSelfBillingInvoicesPage;
